import type { TermFragment } from '../../classes/classes.graphql.generated';

export function getTermStartAndEndDates(terms: TermFragment[] | undefined) {
  return {
    start: terms ? new Date(terms[0].start) : new Date(),
    end: terms ? new Date(terms[terms.length - 1].end) : new Date(),
  };
}
